import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Address, BillingAccount, DataCustomerBOperator, DataCustomerCountry, DataCustomerHq, DataCustomerLeadOperator } from '../creazione-nuovo-customer/creazione-nuovo-customer-costants';
import { countries } from 'countries-ts';

@Component({
  selector: 'app-customer-country',
  templateUrl: './customer-country.component.html',
  styleUrls: ['./customer-country.component.css']
})
export class CustomerCountryComponent implements OnInit {
  countryOptions: string[] = countries
    .map((country) => country.label)
    .sort((left, right) => left.localeCompare(right));

  @Input() customerDto: DataCustomerLeadOperator;

  @Input() isDisabledFormCountry: boolean;

  @Input() tendinaAgreements: any[];

  @Output() changeCreationStepCustomerDataCountryItemEvent = new EventEmitter<string>();

  @Output() previousStepEvent = new EventEmitter<string>();

  @Output() updateCustomerDataCountryItemEvent = new EventEmitter<DataCustomerLeadOperator>();

  @Output() saveCustomerCountryEvent = new EventEmitter<DataCustomerLeadOperator>();


  listCountry: DataCustomerCountry[] = [];

  listBOperator: DataCustomerBOperator[] = [];
  ngOnDestroy: () => void;



  constructor(public toastr: ToastrManager) { }

  ngOnInit(): void {
    this.initializeFormCustomerDataCountry();

  }

  initializeFormCustomerDataCountry() {
    this.listBOperator = this.customerDto ? this.customerDto.listBOperator : [];
    for (let bOperator of this.listBOperator) {
      if (bOperator.listCountry.length == 0) {
        let country: DataCustomerCountry = {
          globalCustomerId: bOperator.bOperatorGlobalCustomerId,
          countryName: '',
          note: '',
          customerBillingAccount: [{
            id: '',
            address: {
              name: '',
              city: '',
              country: '',
              postCode: '',
              streetName: '',
              streetNr: '',
              givenName: '',
              title: ''
            }
          }],
          deliveryAddress: {
            name: '',
            city: '',
            country: '',
            postCode: '',
            streetName: '',
            streetNr: '',
            givenName: '',
            title: ''
          },
          countryCustomerId: '',
          localAgreement: '',
          organizationId: '',
          operator: bOperator.bOperator,
          listAffiliate: [],
          sla: ''
        }
        bOperator.listCountry.push(country);
      } else {
        for (let nation of bOperator.listCountry) {
          if (!nation.customerBillingAccount) {
            let arr: BillingAccount[] = [
              {
                id: '',
                address: {
                  name: '',
                  city: '',
                  country: '',
                  postCode: '',
                  streetName: '',
                  streetNr: '',
                  givenName: '',
                  title: ''
                }
              }
            ];
            nation.customerBillingAccount = arr;
          } else {
            for (let acc of nation.customerBillingAccount) {
              if (!acc.address) {
                acc.address = {
                  name: '',
                  city: '',
                  country: '',
                  postCode: '',
                  streetName: '',
                  streetNr: '',
                  givenName: '',
                  title: ''
                }
              }
            }
          }
          if (!nation.deliveryAddress) {
            nation.deliveryAddress = {
              name: '',
              city: '',
              country: '',
              postCode: '',
              streetName: '',
              streetNr: '',
              givenName: '',
              title: ''
            }
          }
        }
      }
    }
  }



  backToStepCustomerDataBOperator() {
    this.updateCustomerCountryData();
    this.previousStepEvent.emit("customer-data-bOperator");
  }

  goToStepCustomerAffiliate() {
    if (this.allValidCountries()) {
      this.updateCustomerCountryData();
      this.changeCreationStepCustomerDataCountryItemEvent.emit("customer-data-affiliate");
    }

  }

  updateCustomerCountryData() {
    if (this.listBOperator.length > 0) {
      this.customerDto.listBOperator = this.listBOperator;
    }
    this.updateCustomerDataCountryItemEvent.emit(this.customerDto);
  }

  resetForm() {
    if (this.listBOperator.length > 0) {
      for (let bOperator of this.listBOperator) {
        if (bOperator.listCountry.length > 0) {
          for (let elem of bOperator.listCountry) {
            elem.globalCustomerId = bOperator.bOperatorGlobalCustomerId;
            elem.countryName = '';
            elem.note = '';
            elem.customerBillingAccount = [{
              id: '',
              address: {
                name: '',
                city: '',
                country: '',
                postCode: '',
                streetName: '',
                streetNr: '',
                givenName: '',
                title: ''
              }
            }];
            elem.deliveryAddress = {
              name: '',
              city: '',
              country: '',
              postCode: '',
              streetName: '',
              streetNr: '',
              givenName: '',
              title: ''
            },
              elem.countryCustomerId = '';
            elem.localAgreement = '';
            elem.organizationId = '';
            elem.operator = bOperator.bOperator;
            elem.listAffiliate = [];
          }
        }
      }



    }
  }

  customerDataCountryFormDisabled() {
    let result: boolean = false;
    let numOfCountry: number = 0;
    if (this.listBOperator.length > 0) {
      for (let bOperator of this.listBOperator) {
        if (bOperator.listCountry.length > 0) {
          for (let elem of bOperator.listCountry) {
            numOfCountry++;
            if (!elem.countryName || !elem.countryCustomerId
              || !elem.sla) {
              return true;
            }
          }
        }
      }
    }
    if (numOfCountry == 0) {
      return true;
    }

    return result;
  }



  saveCustomer() {
    if (this.allValidCountries()) {
      this.updateCustomerCountryData();
      this.saveCustomerCountryEvent.emit(this.customerDto);
    }

  }

  disabledForm() {
    return this.isDisabledFormCountry;
  }

  addCountryToBOperator(bOperator: DataCustomerBOperator) {
    let data: DataCustomerCountry = {
      globalCustomerId: bOperator.bOperatorGlobalCustomerId,
      countryName: '',
      note: '',
      customerBillingAccount: [{
        id: '',
        address: {
          name: '',
          city: '',
          country: '',
          postCode: '',
          streetName: '',
          streetNr: '',
          givenName: '',
          title: ''
        }
      }],
      deliveryAddress: {
        name: '',
        city: '',
        country: '',
        postCode: '',
        streetName: '',
        streetNr: '',
        givenName: '',
        title: ''
      },
      countryCustomerId: '',
      localAgreement: '',
      organizationId: '',
      operator: bOperator.bOperator,
      listAffiliate: [],
      sla: ''
    }
    bOperator.listCountry.push(data);
  }



  getCountryName(country?: DataCustomerCountry) {
    if (country && !country.countryName) {
      return "Country";
    } else if (country && country.countryName) {
      return "Country " + country.countryName;
    } else {
      return "";
    }
  }

  viewAddCountry(bOperator: DataCustomerBOperator, country: DataCustomerCountry) {
    let index = bOperator.listCountry.indexOf(country);
    if (index == (bOperator.listCountry.length - 1)) {
      return true;
    } else {
      return false;
    }
  }

  viewRemoveCountry(bOperator: DataCustomerBOperator, country: DataCustomerCountry) {
    let index = bOperator.listCountry.indexOf(country);
    let lastIndex: boolean = index == (bOperator.listCountry.length - 1);
    if (lastIndex && !this.customerCountryAlmenoUnCampoObbligatorioCompilato(country)) {
      return true;
    } else {
      return false;
    }

  }

  customerCountryAlmenoUnCampoObbligatorioCompilato(country: DataCustomerCountry) {
    let res: boolean = false;
    if (country.countryCustomerId || country.countryName
      || this.almenoUnCampoDiUnBillingAccountCompilato(country.customerBillingAccount) || this.deliveryAddressAlmenoUnCampoCompilato(country.deliveryAddress)) {
      res = true;
    }
    return res;
  }

  removeCountry(bOperator: DataCustomerBOperator, country: DataCustomerCountry) {
    let index = bOperator.listCountry.indexOf(country);
    bOperator.listCountry.splice(index, 1);
  }



  checkValidationdeliveryAddress(address: Address) {
    let result: boolean = true;
    if (!address || !address.city || !address.country || !address.name
      || !address.postCode || !address.streetName
      || !address.streetNr) {
      return false;
    }


    return result;
  }

  deliveryAddressAlmenoUnCampoCompilato(address: Address) {
    let result: boolean = false;
    if (address) {
      if (address.city || address.country || address.name
        || address.postCode || address.streetName
        || address.streetNr) {
        return true;
      }
    }
    return result;
  }

  almenoUnCampoDiUnBillingAccountCompilato(billingAccounts: BillingAccount[]) {
    let result: boolean = false;
    if (billingAccounts && billingAccounts.length > 0) {
      for (let acc of billingAccounts) {
        if (acc.id) {
          return true;
        }
        if (acc.address) {
          if (acc.address.city || acc.address.country || acc.address.name
            || acc.address.postCode || acc.address.streetName
            || acc.address.streetNr) {
            return true;
          }
        }
      }
    }

    return result;
  }

  addBillingAccount(country: DataCustomerCountry) {
    let data: BillingAccount = {
      id: '',
      address: {
        name: '',
        city: '',
        country: '',
        postCode: '',
        streetName: '',
        streetNr: '',
        givenName: '',
        title: ''
      }
    };
    country.customerBillingAccount.push(data);


  }

  viewAddBillingAccount(account: BillingAccount, country: DataCustomerCountry) {
    let index = country.customerBillingAccount.indexOf(account);
    if (index == (country.customerBillingAccount.length - 1)) {
      return true;
    } else {
      return false;
    }
  }

  viewRemoveBillingAccount(account: BillingAccount, country: DataCustomerCountry) {
    let index = country.customerBillingAccount.indexOf(account);
    let lastIndex: boolean = index == (country.customerBillingAccount.length - 1);
    if (lastIndex && !this.almenoUnCampoBillingAccountCompilato(account)) {
      return true;
    } else {
      return false;
    }

  }



  removeBillingAccount(country: DataCustomerCountry, billingAccount: BillingAccount) {
    let index = country.customerBillingAccount.indexOf(billingAccount);
    country.customerBillingAccount.splice(index, 1);
  }

  almenoUnCampoBillingAccountCompilato(billingAccount: BillingAccount) {
    let result: boolean = false;

    if (billingAccount.id) {
      return true;
    }
    if (billingAccount.address) {
      if (billingAccount.address.city || billingAccount.address.country || billingAccount.address.name
        || billingAccount.address.postCode || billingAccount.address.streetName
        || billingAccount.address.streetNr) {
        return true;
      }
    }



    return result;
  }

  viewAddCountryZeroCountry(bOperator: DataCustomerBOperator) {
    if (bOperator.listCountry.length == 0) {
      return true;
    } else {
      return false;
    }


  }

  viewAddBillingAccountZeroBillingAccount(country: DataCustomerCountry) {
    if (country.customerBillingAccount && country.customerBillingAccount.length == 0) {
      return true;
    } else {
      return false;
    }


  }

  getBOperatorId(bOperator?: DataCustomerBOperator) {
    if (bOperator && !bOperator.bOperator) {
      return "B Operator";
    } else if (bOperator && bOperator.bOperator) {
      return "B Operator " + bOperator.bOperator;
    } else {
      return "";
    }
  }

  onChangeLocalAgreement(newValue: string, bOperator: DataCustomerBOperator, countrySelected: DataCustomerCountry) {
    console.log("newValue", newValue);
    if (this.listBOperator && this.listBOperator.length > 0) {
      let bOp = this.listBOperator.find(element => element.bOperatorGlobalCustomerId == bOperator.bOperatorGlobalCustomerId);
      if (bOp && bOp.listCountry && bOp.listCountry.length > 0) {
        let country = bOp.listCountry.find(elem => elem.countryCustomerId == countrySelected.countryCustomerId
          && elem.countryName == countrySelected.countryName);
        if (country && country.listAffiliate && country.listAffiliate.length > 0) {
          for (let affiliate of country.listAffiliate) {
            affiliate.localAgreement = newValue;
            if (affiliate && affiliate.listDepartment && affiliate.listDepartment.length > 0) {
              for (let department of affiliate.listDepartment) {
                department.localAgreement = newValue;
              }
            }
          }
        }
      }
    }
    this.updateCustomerCountryData();
  }

  customerDataCountryFormNextDisabled() {
    let result: boolean = false;
    let numOfCountry: number = 0;
    if (this.listBOperator.length > 0) {
      for (let bOperator of this.listBOperator) {
        if (bOperator.listCountry.length > 0) {
          for (let elem of bOperator.listCountry) {
            numOfCountry++;
            if (!elem.countryName ||
              !elem.countryCustomerId
              || !elem.sla) {
              return true;
            }
          }
        }
      }
    }
    if (numOfCountry == 0) {
      return true;
    }

    return result;
  }

  allValidCountries() {
    let result: boolean = true;
    for (let elem of this.listBOperator) {
      if (elem.listCountry && elem.listCountry.length > 0) {
        for (let i = 0; i < elem.listCountry.length; i++) {
          for (let j = i + 1; j < elem.listCountry.length; j++) {
            if (elem.listCountry[i].countryName == elem.listCountry[j].countryName) {
              this.toastr.errorToastr('Country ' + elem.listCountry[i].countryName + ' must be unique for the B Operator ' + elem.bOperator + '!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
              return false;
            }
          }
        }
      }
    }

    return result;
  }



}
